// extracted by mini-css-extract-plugin
export default {"collapse__header":"CollapseContent_collapse__header__3XlML","collapse__icon":"CollapseContent_collapse__icon__VgL2N","collapse__filter":"CollapseContent_collapse__filter__oqIGw"};